import React from 'react';
import { useCommonStyles } from '../../materialConfig/commonStyles';
import { BaseTypography } from "src/components/common";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from 'react-router-dom';
import guideImg from "../../assets/images/media-profile.jpg";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '50px 100px',
        "@media (max-width:1200px)": {
            padding: '50px 80px'
        },
        "@media (max-width:991px)": {
            padding: '50px 20px'
        },
    },
    heading: {
        textDecoration: "underline",
        margin: "0 0 20px"
    },
    list:{
        fontSize: "1rem",
        listStyle: "auto",
        margin: "0 0 10px"
    },
    dFlex:{
        display: "flex",
        alignItems: "center",
        gap: "20px",
        "@media (max-width:991px)": {
            flexWrap: "wrap"
        },
    },
    content:{
        flexBasis: "75%",
        "@media (max-width:991px)": {
            flexBasis: "100%"
        },
    },
    img:{
        flexBasis: "25%",
        "@media (max-width:991px)": {
            flexBasis: "100%"
        },
    }
}));

export const Beginnersguide: React.FC = () => {
    const commonClasses = useCommonStyles();
    const classes = useStyles();  
    return (
        <div className={`${commonClasses.container} ${classes.root}`}>
            <div className={classes.dFlex}>
                <div className={classes.content}>
                    <BaseTypography className={classes.heading} gutterBottom="true" variant="h3">
                        So, you’ve written a book. Now, how are you selling it?
                    </BaseTypography>
                    <BaseTypography gutterBottom="true">
                        Writing a book is no mean feat. You have put many hours into it, sacrificing valuable family time. You have bundled all your experience into its pages, possibly wondering whether you are giving away too much in the process.
                    </BaseTypography>
                    <BaseTypography gutterBottom="true">
                        Yet the publisher is unlikely to offer you much sales support. In fact, you are probably obliged to purchase a large number yourself. There is probably also very little promotion of your book. This is also left up to you. So, in addition to being a published author, you now also need to become an accomplished marketer.
                    </BaseTypography>
                    <BaseTypography gutterBottom="true">
                        One way to do this is to promote yourself as a subject matter expert in the media. Publishers and broadcasters of traditional print, radio and television programs have an insatiable appetite for excellent speakers. Podcasters and conference organisers are also on a constant lookout for fresh, interesting speakers to take part in interviews and panel discussions.
                    </BaseTypography>
                    <BaseTypography gutterBottom="true">
                        The trouble is, how do you appear on their radar? Why should they be speaking with you? You might not have anything to announce that would warrant sending them a press release, and even if you do there is no guarantee journalists will pick it up.
                    </BaseTypography>
                    <BaseTypography gutterBottom="true">
                        To get yourself in front of content producers, you need five things:
                    </BaseTypography>
                </div>
                <div className={classes.img}>
                    <img src={guideImg} alt="guide lines" />
                </div>
            </div>
            <ol>
                <li className={classes.list}>
                    <strong>A newsworthy angle – </strong>
                    Have an interesting point to make about your subject matter. How is it relevant to a journalist? What would make a reporter want to talk to you about it? A good way to hone this is by writing down your point and inviting an associate to formulate five impactful questions to explore it. If they are stuck because there is nothing to ask, go back to the drawing board. 
                </li>
                <li className={classes.list}>
                    <strong>Real-life examples – </strong>
                    Journalists love guests who are able to explain complex topics using easy-to-follow case studies, ideally (though not necessarily) with real companies and people mentioned. Gather a variety of stories that allow even laypeople to understand.
                </li>
                <li className={classes.list}>
                    <strong>Availability at short notice – </strong>
                    Journalists often need comments within a few hours, certainly within the day, so they can include them in their story before the issue becomes old news. Make yourself available when the reporter really needs it and they are likely to come back to you again and again.
                </li>
                <li className={classes.list}>
                    <strong>Videos of prior speaking engagements – </strong>
                    if you have appeared previously in the media or on stage discussing your subject matter, be sure to have recordings handy to demonstrate your knowledge to any prospective reporter, and to demonstrate you are good talent. Pro tip: if you don’t enjoy public speaking, get coaching here (commscoaching.contactsbook.asia)  
                </li>                
                <li className={classes.list}>
                    <strong>ContactsBook.Asia profile – </strong>
                    How will journalists find you? That’s where this platform comes in. If you don’t have anything newsworthy to announce journalists can still find you. The site has a database of 500 reporters, event managers and podcasters, and growing. In addition to listing your profile, the site also offers a short promotional video that looks great on social media, news release publication, and the chance to give a background briefing on video. 
                </li>
            </ol>
            <BaseTypography gutterBottom="true">
                Having put so much effort into your book you owe it to yourself to give yourself the bests chance of success. For less than the price of one book sale per month you can get your profile out there. 
            </BaseTypography>
            <BaseTypography gutterBottom="true">
                <Link to="/register/expert/1">Click here to register now. </Link>
            </BaseTypography>
        </div>
    )
}